<template>
  <icon-card
    class="rationale-card"
    :class="{ selected, correct }"
  >
    <template #icon>
      <radio-button
        :answered="answered"
        :selected="selected"
        :correct="correct"
        :use-answer-labels="useAnswerLabels"
        :index="index"
        :is-sata="isSata"
        size="small"
      ></radio-button>
    </template>
    <template #title>
      <span
        v-html="changeRootPTagToSpan(answerHtml)"
      ></span>
    </template>
    <div
      class="rationale"
      v-html="rationale"
    ></div>
  </icon-card>
</template>

<script>
import IconCard from './IconCard.vue';
import RadioButton from '@/components/flashcards-v2/fragments/RadioButton';
import { changeRootPTagToSpan } from '@/utils';

export default {
  components: {
    IconCard,
    RadioButton,
  },
  props: {
    answered: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    isSata: {
      type: Boolean,
      default: false,
    },
    answerHtml: {
      type: String,
      default: 'the answer html',
    },
    rationale: {
      type: String,
      default: 'the rationale',
    },
    useAnswerLabels: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeRootPTagToSpan,
  },
};
</script>

<style lang="scss">
/* last child of class rationale should have a margin-bottom of 0, and this is a deep property */
.rationale {
  p {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.rationale-card {
  &.selected.correct {
    background-color: #ECFDF3;
  }

  &.selected {
    border-radius: var(--radius-xs);
    background-color: #FEF3F2;
  }
}
</style>
